import { Button, DialogContent, Paper, Typography } from "@mui/material";
import React from 'react';
import { assertText, datetimeSimplifier } from "../../redux/conversation/conversationSlice";
import { SurveyInfo, SurveyType } from "../../redux/survey/surveySlice";

interface SurveyPreviewProps {
    survey: SurveyInfo;
}

const SurveyPreview: React.FC<SurveyPreviewProps> = ({ 
    survey, 
}) => {
    return (
        <>
            <DialogContent>
                {
                    survey.questions && survey.questions.length > 0 &&
                    survey.questions.map((question) => {
                        return <Paper key={`${survey.id}-question-${question.id}`} elevation={10} sx={{ padding: "10px", marginBottom: "10px", backgroundColor: "#f5f5f5" }}>
                            <Typography variant="h6" sx={{ marginTop: "0px" }}>
                                {question.title}
                            </Typography>
                            <Typography variant="body1" sx={{ marginTop: "0px", marginBottom: "3px" }}>
                                {assertText(question.description)}
                            </Typography>
                            
                            {question.options?.map((option, index) => (
                                <Button key={`preview-option-${index}`} variant="outlined" fullWidth sx={{ mb: 1, textTransform: "none" }}>
                                    {option.title}
                                </Button>
                            ))}
                        </Paper>;
                    })
                }
                <Typography variant="body2" sx={{ marginTop: "0px", fontSize: "10px", fontStyle: "italic",
                    color: (theme) => survey.type === SurveyType.PRIVATE_PER_STUDENT ? theme.palette.text.primary : theme.palette.text.secondary
                }}>
                    Um voto por {survey.type === SurveyType.PRIVATE_PER_STUDENT ? "aluno" : "usuário"}
                </Typography>
                <Typography variant="body2" sx={{ marginTop: "0px", fontSize: "10px", fontStyle: "italic",
                    color: (theme) => theme.palette.text.secondary
                }}>
                    Válido até: {datetimeSimplifier(survey.endAt)}
                </Typography>
            </DialogContent>
        </>
    );
};

export default SurveyPreview;
